import { render } from "./featured-products.vue?vue&type=template&id=86fff93c"
import script from "./featured-products.vue?vue&type=script&lang=js"
export * from "./featured-products.vue?vue&type=script&lang=js"

import "./featured-products.vue?vue&type=style&index=0&id=86fff93c&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__